import { render, staticRenderFns } from "./HeaderAbout.vue?vue&type=template&id=52b9503c&scoped=true&"
import script from "./HeaderAbout.vue?vue&type=script&lang=js&"
export * from "./HeaderAbout.vue?vue&type=script&lang=js&"
import style0 from "./HeaderAbout.vue?vue&type=style&index=0&id=52b9503c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b9503c",
  null
  
)

export default component.exports